import { AnalyticsField, DashboardsViews, DashboardWidgetName } from '@types'

export default async (dashboardsViews: DashboardsViews[]) => {
  return dashboardsViews.reduce((acc, dashboardView) => {
    let isUpdated = false
    const widgets = dashboardView.widgets?.map(widget => {
      if (
        widget.name === DashboardWidgetName.Commitments && 
        !!widget.attrs.columns?.[0]?.field
      ) {
        isUpdated = true
        return {
          ...widget,
          attrs: {
            ...widget.attrs,
            columns: widget.attrs.columns.filter((column: any) => column.enabled).map((column: any) => {
              if (column.field === AnalyticsField.ACCOUNT_ID) {
                return AnalyticsField.ACCOUNT_NAME
              }
              if (column.field === AnalyticsField.ASSET_ID) {
                return AnalyticsField.ASSET_NAME
              }
              return column.field
            }),
          },
        }
      }
      return widget
    })
    if (isUpdated) {
      acc.push({
        ...dashboardView,
        widgets,
      })
    }
    return acc
  }, [] as DashboardsViews[])
}
